/**
 * @fileoverview ロギング機能付きのフェッチユーティリティ
 *
 * このファイルでは、標準のfetch APIをラップして、リクエストとレスポンスの
 * ロギング機能を追加したユーティリティ関数を提供します。
 * デバッグやトラブルシューティングを容易にするために、API通信の詳細を
 * 自動的にログに記録します。
 */

/**
 * ロギング機能付きのフェッチ関数
 *
 * 標準のfetchと同じインターフェースを持ちながら、リクエストとレスポンスの
 * 詳細情報を自動的にログに記録します。開発環境では詳細なログを出力し、
 * 本番環境ではログレベルを調整します。
 *
 * @param {RequestInfo|URL} input - フェッチするリソースのURL
 * @param {RequestInit} [init] - カスタムリクエスト設定オブジェクト
 * @returns {Promise<Response>} レスポンスを含むPromise
 * @throws {Error} ネットワークエラーやその他の例外が発生した場合
 */
import { logger } from "@/logger";

export const fetchWithLog = async (
  input: string | URL | Request,
  init?: RequestInit
): Promise<Response> => {
  const request = new Request(input, init);
  logger.info(request);

  const response = await fetch(request);
  logger.info(response);

  return response;
};
